import React, { useState } from "react";
import { Box, Typography, Button, Grid, useTheme } from "@mui/material";
import QrCodeIcon from "@mui/icons-material/QrCode";
import BBPSServices from "./BBPSservices";
import ComingSoon from "../Utils/ComingSoon";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";



const Secondhalfcontent = ({ billPaymentRef }) => {
  const theme = useTheme();
  const [openComingSoon, setOpenComingSoon] = useState(false);
  const isDark = theme.palette.mode === "dark";

  const navigate = useNavigate();

  const user = {
    UPIVPA: "",
  };
 
 const subWallets = useSelector((state) => state.auth.subWallets);
console.log("Redux subWallets:", subWallets);

   const navigatetoexpensemanagement = () =>{
     navigate("/dashboard/expensemanagement")
   }

  return (
    <>
       {subWallets?.length > 0 && (
      <Box sx={{px:{xs:2,sm:3,md:4},py:2}}>
      {/* <Grid container spacing={2}>
        <Grid item xs={12} md={7}>
          <Box sx={{
            display:"flex",justifyContent:"space-between",alignItems:"center",
            background:"linear-gradient(135deg,#f0fdf4 0%,#dcfce7 100%)",
            borderRadius:3,p:2.5,border:"1px solid #bbf7d0",gap:2,
          }}>
            <Box>
              <Typography sx={{fontWeight:700,fontSize:14,color:"#15803d",mb:0.5}}>Expense Cards</Typography>
              <Typography sx={{fontSize:12,color:"#6b7280"}}>Gift · Food · Travel · Fuel cards</Typography>
            </Box>
            <Button variant="contained" onClick={navigatetoexpensemanagement}
              sx={{background:"linear-gradient(135deg,#16a34a,#22c55e)",color:"white",fontSize:12,px:2,borderRadius:2,whiteSpace:"nowrap"}}>
              View Cards
            </Button>
          </Box>
        </Grid>

        <Grid item xs={12} md={5}>
          <Box sx={{
            display:"flex",justifyContent:"space-between",alignItems:"center",
            background:"linear-gradient(135deg,#fef9f0 0%,#fffbeb 100%)",
            borderRadius:3,p:2.5,border:"1px solid #fde68a",gap:2,
          }}>
            <Box sx={{display:"flex",alignItems:"center",gap:1.5}}>
              <Box sx={{width:40,height:40,bgcolor:"white",borderRadius:2,display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 2px 8px rgba(0,0,0,0.08)"}}>
                <QrCodeIcon sx={{fontSize:22,color:"#d97706"}}/>
              </Box>
              <Box>
                <Typography sx={{fontWeight:700,fontSize:14,color:"#92400e"}}>My QR Code</Typography>
                <Typography sx={{fontSize:11,color:"#9ca3af"}}>Scan & Pay instantly</Typography>
              </Box>
            </Box>
            <Button variant="contained" onClick={()=>setOpenComingSoon(true)}
              sx={{bgcolor:"#f59e0b",color:"white",fontSize:12,px:2,borderRadius:2,whiteSpace:"nowrap","&:hover":{bgcolor:"#d97706"}}}>
              View QR
            </Button>
          </Box>
        </Grid>
      </Grid> */}
      </Box>
      )}

      <div ref={billPaymentRef}>
        <BBPSServices />
      </div>

      <ComingSoon
        open={openComingSoon}
        onClose={() => setOpenComingSoon(false)}
      />
    </>
  );
};

export default Secondhalfcontent;
